import identity from './identity.js';
import overRest from './_overRest.js';
import setToString from './_setToString.js';

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

export default baseRest;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseRest.js
// module id = 1000
// module chunks = 0